import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UploadListDialogComponent } from '../upload-list-dialog/upload-list-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from './../../api/translate.service';
import { UserProfileService } from '../../api/user-profile.service';
@Component({
  selector: 'iv-upload-list-button',
  templateUrl: './upload-list-button.component.html',
  styleUrls: ['./upload-list-button.component.scss']
})
export class UploadListButtonComponent {

  @Input() buttonText: string;
  @Input() uploadObject;
  @Input() required = true;
  @Input() transactionStatus: string;
  /**
  * Tooltip message to be displayed on hover
  */
  @Input() tooltipMessage: string = 'The maximum size of each uploaded file is not to exceed 50MB';

  @Output() loadList = new EventEmitter();

  constructor(public dialog: MatDialog,
    private translateService: TranslateService,
    private userProfileService: UserProfileService) { }

  openDialog() {
    const dialogRef = this.dialog.open(UploadListDialogComponent, {
      width: '400px',
      panelClass: 'upload-modal',
      disableClose: true,
      data: {
        uploadObject: this.uploadObject
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadList.emit();
    });
  }
  getTranslation(key: string): string {
    return this.translateService.getTranslation(key);
  }

  getUserCountry() {
    return this.userProfileService.getCountryLocalStorage();
  }
  isFinanceUser() {
    return this.userProfileService.getFinanceUserFlagStorage();
  }

  isButtonDisabled(): boolean {
    return this.userProfileService.shouldDisableActionsForFinanceUser(this.transactionStatus);
  }

}
